import React from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
    >
      {isDark
        ? React.createElement(FiSun as React.ComponentType<{ size?: number }>, { size: 18 })
        : React.createElement(FiMoon as React.ComponentType<{ size?: number }>, { size: 18 })}
    </button>
  );
};

export default ThemeToggle;
